module.exports = __webpack_public_path__ + "img/Pattern06.0021a1f6.png";